// extracted by mini-css-extract-plugin
module.exports = {"title":"errorModal_title__Lfgqk","text":"errorModal_text__A8xL1","contact":"errorModal_contact__He_ze","buttonContainer":"errorModal_buttonContainer__aHxsp"};